import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
// Production-only: never count preview/dev traffic.
const PROD_HOSTS = ["hutanohwevanhu.org", "www.hutanohwevanhu.org"];

function gaEnabled() {
  return Boolean(GA_ID) && PROD_HOSTS.includes(window.location.hostname);
}

// Injects GA4 (gtag.js) once and tracks page views on SPA route changes.
export function Analytics() {
  const location = useLocation();
  const loaded = useRef(false);

  useEffect(() => {
    if (!gaEnabled() || loaded.current) return;
    loaded.current = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    // We send page_view manually on each route change, so disable the automatic first one.
    window.gtag("config", GA_ID, { send_page_view: false });
  }, []);

  useEffect(() => {
    if (!gaEnabled() || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
